
import { GenericConstant } from "../utils/GenericConstant";

const toTitleCase = (str?: string | null) => {
    return typeof str === "string" ? str?.replace(/\w\S*/g, (txt) => {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    }) : ""
}
const getValueById = (mainArr: any[], selected: [], id: any, value: any) => {
    const getNameById = (subId: any) => mainArr.find((m: any) => m[id] === subId)?.[value] ?? id;
    const names = (selected || []).map((id) => getNameById(id));
    return names.length ? names.join(",") : [];

};
const addIdIncrement = (rows: any) => {
    return Array.isArray(rows) ?
        rows?.map((row: any, i: number) => ({
            ...row,
            serialNo: i + 1,
        })) : []
}

const addIdIncrementWithAddCrop = (rows: any, crops: any) => {

    return Array.isArray(rows) ? rows.map((row: any, i: number) => ({
        ...row,
        serialNo: i + 1,
        cropName: crops[row.crop] ?? row.crop

    })) : [];
}

const formatDMY = (dateValue: string | number | Date): string => {
    if (dateValue === null || dateValue === undefined || dateValue === '') return '';

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(date);
};

const getCurrentStepName = (steps: [], currentStep: number) => {
    return steps?.find((ele: any) => ele?.protocol_step_id == currentStep)?.['protocol_step_name']
}
const getCurrentStepProtocolId = (steps: [], currentStep: number) => {
    return steps?.find((ele: any) => ele?.protocol_step_id == currentStep)?.['splot_workflow_protocol_id'] ?? ""
}

const parseApiError = (error: any, fallbackMessage: string, filterConfig?: any) => {
    const detail = error?.response?.data?.detail;
    if (Array.isArray(detail) && detail.length > 0) {
        const firstError = detail[0];
        const fieldKey = firstError.loc?.length > 0 ? firstError.loc[firstError.loc.length - 1] : "";
        const errorField = filterConfig?.filter((field: any) => field.name === fieldKey).length
            ? filterConfig.filter((field: any) => field.name === fieldKey)[0].label
            : null;
        const errorMessage = firstError.msg || fallbackMessage;
        return { errorField, errorMessage };
    }
    return { errorField: null, errorMessage: fallbackMessage };
};

const getLocalStorageJSON = <T,>(key: string, fallback: T): T => {
    try {
        const saved = localStorage.getItem(key);
        return saved ? JSON.parse(saved) : fallback;
    } catch { return fallback; }
};

const setLocalStorageJSON = (key: string, value: unknown): void => {
    localStorage.setItem(key, JSON.stringify(value));
};

const removeLocalStorageKeys = (...keys: string[]): void => {
    keys.forEach((k) => localStorage.removeItem(k));
};

/**
 * Rebuilds filter-chip display data from a raw activeFilter request object.
 * Maps numeric IDs back to human-readable names using listValues + field config.
 */
const mapActiveFilterToChips = (
    activeFilter: Record<string, any>,
    fields: any[],
    listValues: Record<string, any[]>
): { name: string; type: string; lable: string; value: string }[] => {
    const chips: { name: string; type: string; lable: string; value: string }[] = [];

    for (const field of fields) {
        const formVal = activeFilter?.[field?.name];

        if (field.type === 'select' && Array.isArray(formVal) && formVal.length > 0) {
            if (field.displayNameOnSel) {
                const getNameById = (id: any) =>
                    listValues[field.list]?.find((m: any) => m[field.listKey] === id)?.[field.listValue] ?? String(id);
                chips.push({ name: field.name, type: field.type, lable: field.label, value: formVal.map(getNameById).join(', ') });
            } else {
                chips.push({ name: field.name, type: field.type, lable: field.label, value: formVal.map(String).join(', ') });
            }
        } else if ((field.type === 'text' || field.type === 'textMulti' || field.type === 'PeoplePicker') && formVal?.length) {
            chips.push({ name: field.name, type: field.type, lable: field.label, value: String(formVal) });
        } else if (field.type === 'dateRange') {
            const reqKeys = field.reqKey?.split('-');
            const fromDate = activeFilter?.[reqKeys?.[0]];
            const toDate = activeFilter?.[reqKeys?.[1]];
            if (fromDate && toDate) {
                chips.push({ name: field.name, type: field.type, lable: field.label, value: `${fromDate} - ${toDate}` });
            }
        }
    }

    return chips;
};

export { toTitleCase, getValueById, addIdIncrement, formatDMY, addIdIncrementWithAddCrop, getCurrentStepName, getCurrentStepProtocolId, parseApiError, getLocalStorageJSON, setLocalStorageJSON, removeLocalStorageKeys, mapActiveFilterToChips }

export const convertToGrams = (value: string) => {
    const isKg = value.toLowerCase().includes("kg")
    const isGrams = !isKg && value.toLowerCase().includes("g")

    const cleaned = removeNonNumericCharacters(convertToUsNumberString(value))
    if (isGrams) return cleaned
    if (isKg) {
        return `${parseFloat(cleaned) * 1000}`
    }
    return value
}

export const removeNonNumericCharacters = (value: string) => {
    // remove all non-numeric characters except for periods
    return value.replace(/[^0-9.]/g, "")
}
export const convertToUsNumberString = (value: string): string => {
    return value.replace(",", ".")
}

export const addIdIncrementWithAddCropSite = (rows: any, crops: any, sites: any) => {

    return rows.map((row: any, i: number) => ({
        ...row,
        serialNo: i + 1,
        cropName: crops[row?.protocol_crop] ?? row?.name,
        siteName: sites[row?.protocol_site] ?? row?.protocol_site

    }));
}


export const numericOnlyKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>
) => {
    if (["e", "E", "+", "-"].includes(e.key)) {
        e.preventDefault();
    }
};


export const checkObjectEmpty = (obj: any,module:string) => {
    let  keysToRemove = GenericConstant.CHECK_EMPTY_EXCEPT[module];
    let copiedObj = {...obj};

    keysToRemove.forEach((key:string) => {
        delete copiedObj[key];
    });


    const isAllEmpty = Object.values(copiedObj).every(value =>
        value === null ||
        value === '' ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0)
    );
    return isAllEmpty;


}
export const checkArray = (arr: any) => {
    return Array.isArray(arr) ? arr :[]

}